import React, { Component } from "react";
import { Row, Col, Card, Button, Steps, Popover } from "antd";
import { connect } from "react-redux";
import { UserAction } from "../../store/actions";
import General_Info from "../../components/generalInfo";
import RMX from "../../assets/images/b-RMX-1.png";
import TextInput from "../../components/input/TextInput";
import SubcriptionCardImg from "../../assets/images/subcription-card.png";
import "./Styles.css";
import ThankYou from "../../assets/images/thankyou.jpg";
import CustomModal from "../../components/modals/customModal";
import LoaderGif from "../../assets/images/ie_loader.gif";

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 12,
        column: "name",
        category_id: 1,
        // totalCount: 0,
        // currentCount: 0,
        // total_pages: 0,
        status: "active",
      },

      categoryName: "Standard Products",

      shipingprice: {
        am_charges: "0.0",
        pm_charges: "0.0",
      },
      price: "",
      cardPayload: {
        name: "",
        number: "",
        cvc: "",
        exp_year: "",
        exp_month: "",
      },
      cardErrorPayload: {
        nameError: "",
        numberError: "",
        cvcError: "",
        exp_monthError: "",
        exp_yearError: "",
      },
    };
  }

  abc = (key) => {
    this.setState({
      filters: {
        ...this.state.filters,
        category_id: key.id,
      },
      categoryName: key.name,
    });
  };
  onHandleChange = (e) => {
    this.setState({
      cardPayload: {
        ...this.state.cardPayload,
        [e.target.name]: e.target.value,
      },
    });
  };

  onSubmit = () => {
    const { number, cvc, exp_month, exp_year, name } = this.state.cardPayload;

    if (
      !name.trim().length ||
      !number.trim().length ||
      !cvc.trim().length ||
      !exp_month.trim().length ||
      !exp_year.trim().length
    ) {
      if (!name.trim().length) {
        this.state.cardErrorPayload.name = "Card name is required.";
      }
      if (!number.trim().length) {
        this.state.cardErrorPayload.numberError = "Card Number is required.";
      }
      if (!exp_month.trim().length) {
        this.state.cardErrorPayload.exp_monthError =
          "Expiry month is required.";
      }
      if (!exp_year.trim().length) {
        this.state.cardErrorPayload.exp_yearError = "Expiry year is required.";
      }
      if (!cvc.trim().length) {
        this.state.cardErrorPayload.cvcError = "Cvc is required.";
      }
      this.setState({
        cardErrorPayload: this.state.cardErrorPayload,
      });
      return;
    }
    this.props.createToken(this.state.cardPayload, () => {
      this.props.getCards(this.state.filter, this.state.radioValue);
      this.setState({
        isOpenCard: false,
      });
    });
  };

  render() {
    if (this?.props?.location?.state?.fromCustom) {
      return <General_Info />;
    }
    const { Step } = Steps;
    const customDot = (dot, { status, index }) => (
      <Popover
        overlayClassName="onhide-popover"
        content={
          <span>
            step {index} status: {status}
          </span>
        }
      >
        {dot}
      </Popover>
    );
    const { name, number, cvc, exp_month, exp_year } = this.state.cardPayload;
    const { nameError, numberError, cvcError, exp_monthError, exp_yearError } =
      this.state.cardErrorPayload;
    return (
      <Row justify="center">
        <Col xl={20} lg={20} xs={22} sm={22} md={22}>
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={22}
              sm={22}
              md={24}
              style={{
                padding: "15px",
                justifyContent: "start",
                display: "flex",
                marginTop: "20px",
              }}
            >
              <img
                src={RMX}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  backgroundRepeat: "no-repeat",
                  top: "-20px",
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={24}
              sm={24}
              md={24}
              className="onhandle-mscreen"
              style={{ marginTop: "25px", marginBottom: "30px" }}
            >
              <Steps current={this.props.count} progressDot={customDot}>
                <Step title="Register" />
                <Step title="Create Profile" />
                <Step title="Add your plant" />
                <Step title="Personlize" />
                <Step title="Build Catalog" />
                <Step title="Subscription" />
              </Steps>
            </Col>
          </Row>
          <Row>
            <Col>
              <h2 className="text-left catalog-heading">
                Subscription Payment
              </h2>
            </Col>
          </Row>
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={24}
              sm={24}
              md={24}
              style={{ marginBottom: "30px" }}
            >
              <Row>
                <Col
                  xl={10}
                  lg={10}
                  xs={24}
                  sm={24}
                  md={24}
                  className="card-padding"
                >
                  <Card className="card-height">
                    <Col>
                      <span className="text-center teal-text-dollar">$</span>
                      <span className="text-center  payment-data-number">
                        1500
                      </span>
                      <span className="text-center payment-data-text">
                        /month
                      </span>
                    </Col>
                    <Col>
                      <h4 className="text-center payment-plan-heading">
                        Basic Plan
                      </h4>
                    </Col>
                    <Col>
                      <p className="text-center ">
                        We've created Stripe Connect for exactly these use
                        cases. With Stripe Connect, you can accept payments for
                        your users without being involved in the flow.
                      </p>
                    </Col>
                  </Card>
                </Col>
                <Col xl={14} lg={14} xs={24} sm={24} md={24}>
                  <Row>
                    <Col
                      span={24}
                      className="text-left catalog-heading-register"
                    >
                      <img
                        src={SubcriptionCardImg}
                        width="70"
                        height="50"
                        alt="#"
                      />
                      <span style={{ padding: "15px" }}>Card Details</span>
                    </Col>
                  </Row>
                  <Row gutter={[0, 20]}>
                    <Col
                      xl={20}
                      lg={20}
                      xs={24}
                      sm={24}
                      md={24}
                      style={{ marginTop: "-35px" }}
                    >
                      <Col span={24}>
                        <TextInput
                          label="Card Holder’s Name"
                          required
                          name="name"
                          onChange={this.onHandleChange}
                          value={name}
                        />
                        <Row>
                          <Col span={24} className="text-right">
                            {" "}
                            <span className="danger-color">
                              {nameError && nameError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <TextInput
                          label="Card Number"
                          required
                          name="number"
                          onChange={this.onHandleChange}
                          value={number}
                          maxLength={16}
                        />
                        <Row>
                          <Col span={24} className="text-right">
                            {" "}
                            <span className="danger-color">
                              {numberError && numberError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <Row gutter={[10, 0]}>
                          <Col span={12}>
                            <TextInput
                              label="Expiry Month"
                              required
                              name="exp_month"
                              onChange={this.onHandleChange}
                              value={exp_month}
                            />
                            <Row>
                              <Col span={24} className="text-right">
                                {" "}
                                <span className="danger-color">
                                  {exp_monthError && exp_monthError}
                                </span>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={12}>
                            <TextInput
                              label="Expiry Year"
                              required
                              name="exp_year"
                              onChange={this.onHandleChange}
                              value={exp_year}
                            />
                            <Row>
                              <Col span={24} className="text-right">
                                {" "}
                                <span className="danger-color">
                                  {exp_yearError && exp_year}
                                </span>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={24}>
                        <TextInput
                          label="CVC"
                          required
                          name="cvc"
                          onChange={this.onHandleChange}
                          value={cvc}
                        />
                        <Row>
                          <Col span={24} className="text-right">
                            {" "}
                            <span className="danger-color">
                              {cvcError && cvcError}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row justify="end">
                <Col
                  xl={4}
                  lg={4}
                  xs={24}
                  sm={24}
                  md={6}
                  style={{ marginTop: "20px" }}
                >
                  {!this.props.isLoading ?
                    <Button
                      style={{
                        backgroundColor: "#ff9800 ",
                        color: "#fff",
                        width: "100%",
                        border: "none",
                      }}
                      onClick={() =>
                        this.props.createToken(this.state.cardPayload, () =>
                          this.setState({
                            isOpenModal: true,
                          })
                        )
                      }>
                      Continue
                    </Button>
                    :
                    <Row justify="end" align="middle">
                      <Col className="text-left" xs={6} sm={6} md={10} lg={8} xl={8}>
                        <img src={LoaderGif} height={"60"} width={"60"} />
                      </Col>
                    </Row>
                  }

                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <CustomModal
          visible={this.state.isOpenModal}
          onCancelModal={() =>
            this.setState({
              isOpenModal: false,
            })
          }
          className="thankyou-modal"
          footer={[
            <Row justify="center">
              <Col span={8}>
                {" "}
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    border: "none",
                  }}
                  block
                  onClick={() => window.open("https://main-frame.com", "_self")}
                >
                  Done
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Col xl={24}>
            <h1 className="text-center">Thank You!</h1>
          </Col>

          <Col span={24}>
            <Row align="middle">
              <Col span={24} className="d-flex justify-content-center">
                <img src={ThankYou} />
              </Col>
              <Col span={24} className="d-flex justify-content-center">
                <span className="text-center ">
                  Your request is pending approval!
                  <br />
                  You will be notified via email.
                </span>
              </Col>
            </Row>
          </Col>
        </CustomModal>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    isLoading: store.UserReducer.isLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createToken: (payload, cb) =>
      dispatch(UserAction.createTokenReq(payload, cb)),
    getPlan: () => dispatch(UserAction.getSubscriptionPlanReq()),
    createSubscription: (payload) =>
      dispatch(UserAction.createSubscriptionReq(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
